import React, { useState, useEffect } from 'react';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { FaQuoteRight } from 'react-icons/fa';
import data from './data';
function App() {
    const [people, setPeople] = useState(data);
    const [index, setIndex] = React.useState(0);

    const nextSlide = () => {
        setIndex((oldIndex)=>{
            let index = oldIndex + 1
            if (index > people.length - 1) {
                index = 0
            }
            return index
        })
    }
    const prevSlide = () => {
        setIndex((oldIndex) => {
            let index = oldIndex - 1
            if (index < 0) {
                index = people.length - 1
            }
            return index
        })
    }

    // useEffect(() => {
    //     const lastIndex = people.length - 1;
    //     if (index < 0) {
    //         setIndex(lastIndex);
    //     }
    //     if (index > lastIndex) {
    //         setIndex(0)
    //     }
    // }, [index, people]);

    useEffect(() => {
        let slider = setInterval(() => {
            setIndex((oldIndex) => {
                let index = oldIndex + 1
                if (index > people.length - 1) {
                    index = 0
                }
                return index
            })
        }, 5000)
        return () => {
            clearInterval(slider)
        }
    }, [index])

    return (
        <section className='section'>
            <div className='title'>
                <h2>
                    <span>/</span>reviews
                </h2>
            </div>
            <div className='section-center'>
                {people.map((person, personIndex) => {
                    const { id, image, name, title, quote } = person;

                    let position = 'nextSlide';
                    console.log('Here is the personIndex')
                    console.log(personIndex);
                    console.log('Here is the index')
                    console.log(index);
                    console.log('end the loop')
                    if (personIndex === index) {
                        position = 'activeSlide';
                    }
                    if (personIndex === index - 1 || (index === 0 && personIndex === people.length - 1)) {
                        position = 'lastIndex';
                    }
                    return (
                        <article className={position} key={id}>
                            <img src={image} alt={name} className='person-img' />
                            <h4>{name}</h4>
                            <p className='title'>{title}</p>
                            <p className='text'>{quote}</p>
                            <FaQuoteRight className='icon' />
                        </article>
                    );
                })}
                <button className='prev' onClick={prevSlide}>
                    <FiChevronLeft />
                </button>
                <button className='next' onClick={nextSlide}>
                    <FiChevronRight />
                </button>
            </div>
        </section>
    );
}

export default App;
